import * as actionTypes from "../actions/actionTypes";

const initialState = {
  qchmgSelected: undefined,
  qchotelSelected: undefined,
  qchotelListSelected: [],
};

export const qcCommon = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.QC_COMMON_SET_HMG:
      return {
        ...state,
        qchmgSelected: action.value,
      };
    case actionTypes.QC_COMMON_SET_SINGLE_HOTEL:
      return {
        ...state,
        qchotelSelected: action.value,
      };
    case actionTypes.QC_COMMON_SET_HOTEL_LIST:
      return {
        ...state,
        qchotelListSelected: action.value,
      };
    default:
      return state;
  }
};

export default qcCommon;
